var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransparentVendorProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237.854 300.01c65.351-92.388 139.589-157.883 222.716-196.484-96.587 24.401-172.991 75.487-229.21 153.258l-49.127-40.876-8.896 32.562z",
    fill: "#19cfba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.002 148.682c53.845-53.845 141.146-53.845 194.991 0 52.325 52.324 53.797 136.238 4.428 190.346l40.065 40.065 2.656-2.655c4.981-4.982 13.133-4.982 18.114-.001l44.219 44.219c4.981 4.981 4.981 13.133 0 18.114l-14.384 14.384c-4.981 4.981-13.133 4.981-18.114 0l-44.219-44.219c-4.981-4.981-4.981-13.132 0-18.114l2.656-2.656-40.065-40.065c-54.109 49.369-138.022 47.897-190.346-4.428-53.846-53.844-53.846-141.145-.001-194.99zm24.705 24.704c-40.202 40.202-40.202 105.382 0 145.583s105.382 40.201 145.583 0c40.202-40.202 40.202-105.382 0-145.583-40.202-40.202-105.382-40.202-145.583 0z",
    fill: "#60b7fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.169 239.761c3.543 0 6.416 2.873 6.416 6.416s-2.873 6.416-6.416 6.416h-26.322c-3.543 0-6.416-2.873-6.416-6.416s2.873-6.416 6.416-6.416zm176.745-163.913c0 3.543-2.873 6.416-6.416 6.416s-6.416-2.873-6.416-6.416v-26.322c0-3.543 2.873-6.416 6.416-6.416s6.416 2.873 6.416 6.416zm-122.321 45.352c2.505 2.505 2.505 6.567 0 9.073-2.505 2.505-6.567 2.505-9.073 0l-18.612-18.613c-2.505-2.505-2.505-6.567 0-9.073 2.505-2.505 6.567-2.505 9.073 0z",
    fill: "#ffbf31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentVendorProfile);
export default __webpack_public_path__ + "static/media/transparent-vendor-profile.606cd070294f2a636e92f457f90a7591.svg";
export { ForwardRef as ReactComponent };